import { GetFieldForFilterAndSort } from '../Util/Field';
import {
  TextFieldOperators,
} from '../Util/Search';

const ApprovalCollectionFields = [
	GetFieldForFilterAndSort(
		"Meta_text_kw256lc[ProjectName].keyword",
		"Project",
		"FieldType_Text",
		"Meta_text_kw256lc[ProjectName]",
		null,
	    "projectList",
	    true,
	    true, // SortOnly - filter doesn't make sense because there's no need when in /projects and /workspace has project subnodes
	),
	GetFieldForFilterAndSort(
		"Meta_text_kw256lc[AssignmentUserEmail].keyword",
		"Assigned to",
		"FieldType_Text",
		null,
	    [
	      {
	          value: "equals",
	          label: "equals",
	      },
	      {
	        value: "notEquals",
	        label: "does not equal",
	      },
	    ],
	    "addressBookItemsList",
	    true,
	),
	GetFieldForFilterAndSort(
		"Meta_date_str256[CreatedOn].string",
		"Created On",
		"FieldType_Date",
	),
	GetFieldForFilterAndSort(
		"Meta_text_kw256lc[ItemCreatedByUserEmail].keyword",
		"Item Created By",
		"FieldType_Text",
		"Meta_text_kw256lc[ItemCreatedByUserEmail]",
		[
	      {
	          value: "equals",
	          label: "equals",
	      },
	      {
	      	value: "notEquals",
	      	label: "does not equal",
	      },
	    ],
	    "addressBookItemsList",
	    true,
	),
	GetFieldForFilterAndSort(
		"Meta_date_str256[ItemCreatedOn].string",
		"Item Created On",
		"FieldType_Date",
	),
	GetFieldForFilterAndSort(
		"Meta_text_kw256lc[Name].keyword",
		"Item Name",
		"FieldType_Text",
		"Meta_text_kw256lc[Name]",
	),
	GetFieldForFilterAndSort(
		"Meta_text_kw256lc[ItemType].keyword",
		"Item Type",
		"FieldType_Text",
		"Meta_text_kw256lc[ItemType]",
		[
	      {
	          value: "equals",
	          label: "equals",
	      },
	    ],
		"approvalItemContentTypes",
		false
	),
	GetFieldForFilterAndSort(
		"Meta_text_kw256lc[ProcessName].keyword",
		"Process",
		"FieldType_Text",
		"Meta_text_kw256lc[ProcessName]",
	),
	GetFieldForFilterAndSort(
		"Meta_text_kw256lc[ProcessElementName].keyword",
		"Stage",
		"FieldType_Text",
		"Meta_text_kw256lc[ProcessElementName]",
	),
	GetFieldForFilterAndSort(
		"Meta_text_kw50lc[Tag].keyword",
		"Tags",
		"FieldType_Text",
		"Meta_text_kw50lc[Tag]",
		null,
	  	"tags",
	  	true,
	  	false,
	  	null,
	  	null,
	  	false,
	  	TextFieldOperators,
	  	true,
	),
];

export default ApprovalCollectionFields;